import styled from "styled-components";
import {
  IconSales,
  IconRepairOrder,
  IconParts,
  IconAccounting,
  CardWrapper,
  CardRow,
  PageHeaderWrapper,
  Chip,
  Heading,
  HEADING_LEVELS,
  HEADING_TYPES,
} from "@cdkglobal/radial";
import type { HeadingProps } from "@cdkglobal/radial";
import type React from "react";

export const SetupsCardRowWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 1rem;
  max-height: 50vh;
  overflow-y: auto;
  scrollbar-width: thin;
  margin: 1rem;
  padding: 1rem;
`;

export const StyledAccountingIcon = styled(IconAccounting)`
  fill: #000000b3;
`;
export const StyledPartsIcon = styled(IconParts)`
  fill: #000000b3;
`;
export const StyledSalesIcon = styled(IconSales)`
  fill: #000000b3;
`;
export const StyledServiceIcon = styled(IconRepairOrder)`
  fill: #000000b3;
`;

export const SetupsDashBoardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0.5rem;
`;

export const SearchBarWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledDepartmentChips = styled(Chip)`
  margin: 0.2rem;
`;

export const SetupsListContainer = styled.div`
  max-height: 80vh;
  margin-bottom: 2rem;
  overflow-y: auto;
  scrollbar-width: thin;
`;

export const DepartmentRow = styled.div`
  > * {
    width: 100%;
  }
`;

export const StyledDashboardPageLabel = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_2,
  type: HEADING_TYPES.HEADING_2,
})`
  display: flex;
  margin-bottom: 1rem;
  color: #196fe1;
  align-items: center;
  margin-top: 0;
`;

export const StyledDepartmentAccordion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`;

export const DepartmentTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FavoriteCard = styled(CardWrapper)`
  cursor: pointer;
  padding: 0.5rem;
  background-color: #f0f0f0;
`;

export const SetupTitle = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_4,
  type: HEADING_TYPES.SUBTITLE_3,
})`
  margin: 0;
  font-weight: 600;
`;

export const SetupDescription = styled.p`
  color: #5f6368;
  margin: 0.5rem 0 1rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const DepartmentLabel = styled.p`
  font-size: 12px;
  background: #eee2ec;
  width: max-content;
`;

export const SectionTitle = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_4,
  type: HEADING_TYPES.SUBTITLE_2,
})`
  margin: 0.2rem;
`;

export const StyledSetupCardWrapper = styled(CardWrapper)`
  cursor: pointer;
  padding: 0.5rem;
`;

export const CardRowStyled = styled(CardRow)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledInfoCard = styled(CardWrapper)`
  max-width: 15rem;
  margin: 1rem;
  padding: 1rem;
`;

export const StyledSetupsTabWrapper = styled(PageHeaderWrapper)`
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
`;

export const SetupsDashboardNavHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
`;

export const SetupDescriptionContent = styled.div`
  padding: 0.5rem 0;

  * {
    font-weight: 600 !important;
  }
`;

export const DynamicIdSelectorWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
`;
